import { CreditCardType, PaymentMethod } from "./paymentMethod";

export enum SubscriptionSource {
  eCom = "eCom",
  Naviga = "Naviga",
  RECURLY = "recurly",
}

export enum SubscriptionResponseStatus {
  ACTIVE = "active",
  CANCELLED = "cancelled",
  PENDING_CANCEL = "pending_cancel",
  PENDING_PAUSE = "pending_pause",
  PAUSED = "paused",
  PENDING_ACTIVATION = "pending_activation",
  Expired = "expired",
}

export interface SubscriptionResponse {
  title: string;
  source: SubscriptionSource;
  status: SubscriptionResponseStatus;
  payment_method?: {
    card_type?: CreditCardType;
    account: string;
    billing_address: {
      country: string;
    };
  };
  subscription_id: string;
  start_date: string;
  end_date: string;
  free_trial_end_date?: string;
  grace_period_end_date?: string;
  paused_start_date?: string;
  cancel_date?: string;
  cancellation_source?: string;
  pid: string;
  product_id?: string;
  next_billing?: {
    date?: string;
    amount: number;
    currency_symbol: string;
  };
  pause_count?: number;
}

export enum SubscriptionStatus {
  ACTIVE = "Active",
  PENDING_CANCEL = "Pending Cancel",
  CANCELLED = "Canceled",
  PENDING_PAUSE = "Pending Pause",
  PAUSED = "Paused",
  PENDING_ACTIVATION = "Pending Activation",
  FREE_TRIAL = "Free Trial",
  GRACE_PERIOD = "Grace Period",
  Expired = "Expired",
  UNKNOWN = "Unknown",
}

export interface SubscriptionModel {
  title: string;
  source: SubscriptionSource;
  status: SubscriptionStatus;
  paymentMethod?: {
    cardType?: CreditCardType;
    account: string;
    billingAddress: {
      country: string;
    };
  };
  subscriptionId: string;
  startDate: string;
  endDate?: string;
  pauseStartDate?: string;
  cancelDate?: string;
  cancellationSource?: string;
  pid: string;
  productId?: string;
  nextBilling?: {
    date?: string;
    amount: number;
    currencySymbol: string;
  };
  actions: string[];
  pauseCount?: number;
}

export interface SubscriptionUpsellDowngradeListResponse {
  pid: string;
  plan_title: string;
  base_price: {
    id: string;
    name: string;
  };
  billing_plan?: {
    id: string;
    name: string;
  };
}

export interface SubscriptionUpsellDowngradeListItem {
  pid: string;
  planTitle: string;
  basePrice: {
    id: string;
    name: string;
  };
  billingPlan?: {
    id: string;
    name: string;
  };
}

export interface RestartSubscriptionModel {
  planTitle: string;
  billingPlanName: string;
  symbol: string;
  amount: number;
  tax: number;
  total: number;
  paymentMethod?: PaymentMethod;
}

export type PauseActor = "User" | "Admin" | "System";

export interface PauseHistoryResponse {
  created_at: string;
  paused_from: string;
  pause_until: string;
  resumed_at: string | null;
  created_by: PauseActor | null;
  resumed_by: PauseActor | null;
  status: string;
}

export interface PauseHistoryItem {
  createdAt: string;
  pausedFrom: string;
  pauseUntil: string;
  resumedAt: string | null;
  createdBy: PauseActor | null;
  resumedBy: PauseActor | null;
  status: string;
}
